module.exports = __webpack_public_path__ + "static/img/8384_phase_function_Paper_Points.d4191f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/8384_phase_function_Paper_Points.png
// module id = NA4g
// module chunks = 0